/* eslint-disable camelcase */
import React, { useEffect, useState, useContext } from 'react';
import Context from 'stores/context';
import PropTypes from 'prop-types';
import {
  TrainingEvaluationStyle,
} from 'components';
import { PostGaAnalytics } from 'utils';
import {
  warningIcon,
} from '../Sidebar/icons';

const TrainingEvaluation = (props) => {
  const context = useContext(Context);
  const { i18n } = context;
  const [loadComponent, setLoadComponent] = useState(null);
  const [showList, setShowList] = useState(false);

  const {
    evaluation,
  } = props;

  const {
    satisfaction_score,
    satisfaction_chips,
  } = evaluation;


  useEffect(() => {
    const printComponent = () => {
      PostGaAnalytics('send', {
        hitType: 'event',
        eventCategory: 'workout:profile',
        eventAction: 'show_training_evaluation',
        eventLabel: 'profile_trainingevaliation',
      });
    };

    if (loadComponent === null && satisfaction_score !== null) {
      printComponent();
      setLoadComponent(true);
    }
  }, [
    satisfaction_score,
    loadComponent,
  ]);

  const toogleMenu = () => {
    const status = !showList;
    setShowList(status);
  };

  const satisfactionScorePositiveExpectation = () => {
    const expectative = 3;
    const satisfaction = parseInt(satisfaction_score, 10);

    return (satisfaction > expectative);
  };

  const hasListChips = () => {
    const hasTrainingGroups = !!(satisfaction_chips && satisfaction_chips.length !== 0);

    return (hasTrainingGroups === false);
  };


  const hiddenAvaliationClient = () => {
    if (satisfactionScorePositiveExpectation()) return true;

    if (hasListChips()) return true;

    return false;
  };

  const listJustifyTraining = () => satisfaction_chips.map(chip => (
    <li className="list-justify__item" key={chip}>
      <div className="list-justify__icon-like">
        <img src={warningIcon} alt="warning" />
      </div>
      <div className="list-justify__title">
        <small className="list-justify__title--small">{chip}</small>
      </div>
    </li>
  ));

  if (hiddenAvaliationClient()) { return ''; }

  return (
    <TrainingEvaluationStyle>
      <nav>
        <div
          className="wrapper-menu-evaluation"
          role="button"
          aria-hidden="true"
          onClick={toogleMenu}
        >
          <span className="name-tab text">{i18n.t('studentAssessment')}</span>
          <button className={`w-collapse-button ${showList ? 'w-collapse-opened' : ''}`} type="button">
            <svg
              width="20"
              height="20"
              viewBox="0 0 30 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.66437 11.2526C7.25159 10.8857 6.61952 10.9229 6.2526 11.3356C5.88568 11.7484 5.92286 12.3805 6.33565 12.7474L15.3356 20.7474C15.7145 21.0842 16.2855 21.0842 16.6644 20.7474L25.6644 12.7474C26.0772 12.3805 26.1143 11.7484 25.7474 11.3356C25.3805 10.9229 24.7484 10.8857 24.3356 11.2526L16 18.6621L7.66437 11.2526Z"
                fill="#fff"
              />
            </svg>
          </button>
        </div>


        <div className="collapse">
          <ul className={`tab__wrapper ${showList ? 'opened' : ''}`}>
            {listJustifyTraining()}
          </ul>
        </div>
      </nav>
    </TrainingEvaluationStyle>
  );
};

TrainingEvaluation.defaultProps = {
  evaluation: {
    satisfaction_score: null,
    satisfaction_chips: [],
  },
};

TrainingEvaluation.propTypes = {
  evaluation: PropTypes.shape({
    satisfaction_score: PropTypes.number,
    satisfaction_chips: PropTypes.array,
  }),
};

export { TrainingEvaluation };
export default TrainingEvaluation;
